import useSWR, { KeyedMutator } from 'swr';
import { SWRFetcher } from '@commenda/utils';
import { TRegisteredAgent } from './types';

// This endpoint can only be called by admin:
export function useAllRegisteredAgents(token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TRegisteredAgent[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `registeredAgent/getAll`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
